import { selectImprovementsBasement } from '../../../redux/features/selectors/propertyDataSelectors/improvementsSelectors.ts';
import { selectTotalBasementCost } from '../../../redux/features/selectors/selectTotalBasementCost.ts';
import { CostApproachTableCostRow } from '../CostApproachTableCostRow.tsx';

export const BasementCostRow = () => (
  <CostApproachTableCostRow
    label="Basement"
    areaSelector={selectImprovementsBasement}
    costSelector={selectTotalBasementCost}
  />
);
